import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { DropdownSelection } from '../../form/dropdownSelection/DropdownSelection.js';
import { CloseIcon } from '../../icons/CloseIcon.js';
import { paymentMethodName, PaymentMethod } from '../paymentMethod/PaymentMethod.js';
import { AddButton } from '../../base/addButton/AddButton.js';
import { Button } from '../../base/button/Button.js';
import '../../base/alert/Alert.js';
import 'clsx';
import '../../base/breadcrumb/Breadcrumb.module.scss.js';
import 'react-aria';
import 'react-stately';
import 'react';
import { IconButton } from '../../base/iconButton/IconButton.js';
import '../../base/calendar/Calendar.module.scss.js';
import 'dayjs';
import '../../base/calendar/calendarGrid/CalendarGrid.module.scss.js';
import '../../base/calendar/calendarGrid/calendarCell/CalendarCell.module.scss.js';
import '../../base/carBackground/CarBackground.module.scss.js';
import '../../base/loader/Loader.module.scss.js';
import '../../base/carLoader/CarLoader.module.scss.js';
import '../../base/card/Card.js';
import '../../base/confirmation/Confirmation.js';
import '../../base/modal/Modal.js';
import '../../base/confirmationModal/ConfirmationModal.module.scss.js';
import '../../base/error/Error.module.scss.js';
import '../../base/tag/Tag.module.scss.js';
import '../../base/vehicleQuote/VehicleQuote.module.scss.js';
import '../../base/insuranceQuote/InsuranceQuote.module.scss.js';
import '../../base/listBox/ListBox.js';
import '../../base/listCard/ListCard.js';
import 'react-dom';
import 'react-transition-group';
import '../../base/popover/Popover.module.scss.js';
import '../../base/progressBar/ProgressBar.module.scss.js';
import '../../base/toast/context/ToastContext.js';
import '../../base/toast/Toast.module.scss.js';
import '../../base/toast/context/ToastContext.module.scss.js';
import '../../base/tooltip/Tooltip.module.scss.js';
import styles from './PaymentMethodsDropdown.module.scss.js';

var PaymentMethodsDropdown = function (_a) {
    var name = _a.name, paymentMethods = _a.paymentMethods, inputProps = _a.inputProps, className = _a.className, style = _a.style, onNewPaymentMethodClick = _a.onNewPaymentMethodClick, onManageWalletClick = _a.onManageWalletClick;
    return (jsx(DropdownSelection, __assign({ label: "Select payment method", footer: jsxs(Fragment, { children: [jsx("div", __assign({ className: styles.footerRow1 }, { children: jsx(AddButton, __assign({ onClick: onNewPaymentMethodClick }, { children: "New payment method" })) })), jsx("div", __assign({ className: styles.footerRow2 }, { children: jsx(Button, __assign({ variant: "text", onClick: onManageWalletClick }, { children: jsx("strong", { children: "Manage wallet" }) })) }))] }), header: function (onClose) { return (jsxs(Fragment, { children: ["Select payment method", jsx(IconButton, __assign({ "aria-label": "Close", variant: "text", color: "dark", onClick: onClose, size: "xxs" }, { children: jsx(CloseIcon, {}) }))] })); }, name: name, inputProps: inputProps, className: className, footerClassName: styles.footer, style: style }, { children: paymentMethods.map(function (paymentMethod) { return (jsx(DropdownSelection.Item, __assign({ textValue: paymentMethodName(paymentMethod) }, { children: jsx(PaymentMethod, __assign({}, paymentMethod)) }), paymentMethod.token)); }) })));
};

export { PaymentMethodsDropdown };
